module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "pay-dialog"
  }, [_c('div', {
    staticClass: "pay-dialog-mask",
    on: {
      "click": _vm.handleClose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pay-dialog-content"
  }, [_c('div', {
    staticClass: "pay-dialog-header"
  }, [_c('span', [_vm._v("支付")]), _vm._v(" "), _c('span', {
    staticClass: "close-btn",
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "srcdoc": _vm.payUrl,
      "frameborder": "0",
      "width": "300",
      "height": "600"
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dea84064","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VipMember/OrderAliPay.vue
// module id = 402
// module chunks = 0